export const CRYPTO_SECRET_KEY = 'eyJzdWIiOiJsYW5kaW5nLWNvbnN1bHRhLXNvYXQiLCJpYXQiOjE1MTYyMzkwMjIsImFsZyI6IkhTMjU2In0';
export const CRYPTO_KEY_BIT_LENGTH = 128;
export const CRYPTO_ITERATIONS = 100;
export const CRYPTO_LENGTH_DIV = 32;
